import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import { LOAD_STAFF_DETAIL, CREATE_STAFF } from '../type';
import {
  loadStaffDetailErrorAction,
  loadStaffDetailSuccessAction,
  createStaffSuccessAction,
  createStaffErrorAction,
} from '../action';

import { staffService } from 'services';

function* loadStaffDetail() {
  while (1) {
    const action = yield take(LOAD_STAFF_DETAIL);
    try {
      const staffDetail = yield call(
        staffService.loadStaffDetail,
        action.payload,
      );
      yield put(loadStaffDetailSuccessAction(staffDetail));
    } catch (err) {
      yield put(loadStaffDetailErrorAction(err));
    }
  }
}

function* createStaff() {
  while (1) {
    const action = yield take(CREATE_STAFF);
    try {
      const createdStaff = yield call(staffService.createStaff, action.payload);
      yield put(createStaffSuccessAction(createdStaff));
      notification.success({
        message: 'Create Patient Successfully',
      });
    } catch (err) {
      notification.error({
        message: 'Failed to create patient',
      });
      yield put(createStaffErrorAction(err));
    }
  }
}

export default function* rootSaga() {
  yield all([loadStaffDetail(), createStaff()]);
}
